<template>
    <div class="continue-section">
        <section-header title="Continue Where You Left Off" icon="fa-arrow-right" :to="{name: 'enrollments'}" :link-text="enrollments ? 'All Course Enrollments (' + enrollments.length + ')' : 'All course enrollments'"/>

        <div v-if="!enrollments">
            <card-skeleton v-for="n in 2" :key="n" :lines="2" class="mb-4"/>
        </div>
        <div v-else-if="continueEnrollments.length">
            <!-- The very same card as the Course Enrollments page -->
            <enrollment v-for="e in continueEnrollments" :key="e.id" :enrollment="e" class="mb-4"/>
        </div>
        <empty-state v-else icon="fa-chalkboard-teacher" text="No courses in progress right now.">
            <router-link :to="{name: 'course-catalog'}"><b-button type="is-light" outlined size="is-small"><i class="fad fa-browsers mr-2"></i>Browse the Catalog</b-button></router-link>
        </empty-state>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SectionHeader from "../framework/SectionHeader";
    import EmptyState from "../framework/EmptyState";
    import CardSkeleton from "../framework/CardSkeleton";
    import Enrollment from "../Enrollment";

    export default {
        name: "ContinueSection",
        components: {SectionHeader, EmptyState, CardSkeleton, Enrollment},
        computed: {
            ...mapGetters(['enrollments', 'continueEnrollments']),
        }
    };
</script>

